var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-autocomplete',_vm._g({attrs:{"rounded":true,"outlined":"","dense":"","label":"categoria","height":"30","items":_vm.finalItems},on:{"change":_vm.setCategory},model:{value:(_vm.category),callback:function ($$v) {_vm.category=$$v},expression:"category"}},on))]}}])},[_c('span',[_vm._v("Filtro de categoria")])])}
var staticRenderFns = []

export { render, staticRenderFns }